import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useChildStore } from '../../store';
import { useParentCurriculumStore } from '../../store/parentCurriculumStore';
import {
  getCurrentDirectedSequenceItem,
  getQueueItemUrl,
  isDirectedSequenceMode,
  isQueueItemRoute,
} from '../../engine/parent-curriculum-feed';
import { todayStr } from '../../utils/date';

const ALWAYS_ALLOWED_PREFIXES = [
  '/settings',
  '/pricing',
  '/privacy',
  '/terms',
  '/coppa',
  '/status',
  '/welcome',
  '/login',
  '/signup',
  '/verify-email',
  '/reset-password',
  '/forgot-password',
];

function isAlwaysAllowed(pathname: string): boolean {
  return pathname === '/' || ALWAYS_ALLOWED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function DirectedSequenceGate() {
  const location = useLocation();
  const { children, activeChildId } = useChildStore();
  const child = children.find((candidate) => candidate.id === activeChildId);
  const queue = useParentCurriculumStore((s) => s.queue);
  const settingsPatch = useParentCurriculumStore((s) =>
    child ? s.settingsByChild[child.id] : undefined,
  );

  const lockActive = child ? isDirectedSequenceMode(child.id) : false;
  const currentItem = useMemo(
    () => child ? getCurrentDirectedSequenceItem(child, todayStr()) : null,
    [child, queue, settingsPatch],
  );

  if (!child || !lockActive) return <Outlet />;

  if (isAlwaysAllowed(location.pathname)) return <Outlet />;

  if (currentItem && isQueueItemRoute(currentItem, location.pathname)) {
    return <Outlet />;
  }

  return (
    <Navigate
      to={currentItem ? getQueueItemUrl(currentItem) : '/'}
      replace
      state={{ directedSequenceRedirectedFrom: location.pathname }}
    />
  );
}
